<aside class="s2 p-l-2 p-r-2 p-t-1 p-b-1 col-w"
       [style.background-color]="color"
       style="border-radius: 12px;">
    <ng-content />
</aside>